import { useCallback, useSyncExternalStore } from "react";

import { appConfig } from "../config";

const STORAGE_EVENT = "storage";

export interface UserState {
  user: string;
  setUser: (user: string) => void;
  clearUser: () => void;
}

export function useUser(): UserState {
  const user = useSyncExternalStore(subscribe, readUser, () => "");

  const setUser = useCallback((nextUser: string) => {
    window.localStorage.setItem(appConfig.selectedUserStorageKey, nextUser);
    window.dispatchEvent(new Event(STORAGE_EVENT));
  }, []);

  const clearUser = useCallback(() => {
    window.localStorage.removeItem(appConfig.selectedUserStorageKey);
    window.dispatchEvent(new Event(STORAGE_EVENT));
  }, []);

  return { user, setUser, clearUser };
}

function subscribe(onStoreChange: () => void): () => void {
  window.addEventListener(STORAGE_EVENT, onStoreChange);
  return () => window.removeEventListener(STORAGE_EVENT, onStoreChange);
}

function readUser(): string {
  return window.localStorage.getItem(appConfig.selectedUserStorageKey) ?? "";
}
